import { Translation } from "primeng/api";

// Translations for PrimeNG's own internal UI strings (calendar month/day names,
// apply/clear buttons, etc.) keyed by app language code. PrimeNG does not use
// ngx-translate, so these need to be supplied directly via PrimeNGConfig.setTranslation().
export const PRIMENG_LOCALES: Record<string, Translation> = {
  en: {
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    today: "Today",
    clear: "Clear",
    apply: "Apply",
    cancel: "Cancel",
    weekHeader: "Wk",
    chooseYear: "Choose Year",
    chooseMonth: "Choose Month",
    chooseDate: "Choose Date",
    aria: {
      previousPageLabel: "Previous Page",
      prevPageLabel: "Previous Page",
      nextPageLabel: "Next Page",
      rowsPerPageLabel: "Rows per page",
    },
  },
  es: {
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    monthNamesShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    dayNames: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
    today: "Hoy",
    clear: "Limpiar",
    apply: "Aplicar",
    cancel: "Cancelar",
    weekHeader: "Sem",
    chooseYear: "Elegir año",
    chooseMonth: "Elegir mes",
    chooseDate: "Elegir fecha",
    aria: {
      previousPageLabel: "Página anterior",
      prevPageLabel: "Página anterior",
      nextPageLabel: "Página siguiente",
      rowsPerPageLabel: "Filas por página",
    },
  },
  pt: {
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    dayNames: [
      "Domingo",
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado",
    ],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    dayNamesMin: ["Do", "Se", "Te", "Qu", "Qi", "Se", "Sa"],
    today: "Hoje",
    clear: "Limpar",
    apply: "Aplicar",
    cancel: "Cancelar",
    weekHeader: "Sem",
    chooseYear: "Escolher ano",
    chooseMonth: "Escolher mês",
    chooseDate: "Escolher data",
    aria: {
      previousPageLabel: "Página anterior",
      prevPageLabel: "Página anterior",
      nextPageLabel: "Próxima página",
      rowsPerPageLabel: "Linhas por página",
    },
  },
  fr: {
    monthNames: [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ],
    monthNamesShort: [
      "Jan",
      "Fév",
      "Mar",
      "Avr",
      "Mai",
      "Juin",
      "Juil",
      "Aoû",
      "Sep",
      "Oct",
      "Nov",
      "Déc",
    ],
    dayNames: [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
    ],
    dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
    today: "Aujourd'hui",
    clear: "Effacer",
    apply: "Appliquer",
    cancel: "Annuler",
    weekHeader: "Sem",
    chooseYear: "Choisir l'année",
    chooseMonth: "Choisir le mois",
    chooseDate: "Choisir la date",
    aria: {
      previousPageLabel: "Page précédente",
      prevPageLabel: "Page précédente",
      nextPageLabel: "Page suivante",
      rowsPerPageLabel: "Lignes par page",
    },
  },
  nl: {
    monthNames: [
      "Januari",
      "Februari",
      "Maart",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Augustus",
      "September",
      "Oktober",
      "November",
      "December",
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mrt",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dec",
    ],
    dayNames: [
      "Zondag",
      "Maandag",
      "Dinsdag",
      "Woensdag",
      "Donderdag",
      "Vrijdag",
      "Zaterdag",
    ],
    dayNamesShort: ["Zon", "Maa", "Din", "Woe", "Don", "Vri", "Zat"],
    dayNamesMin: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
    today: "Vandaag",
    clear: "Wissen",
    apply: "Toepassen",
    cancel: "Annuleren",
    weekHeader: "Wk",
    chooseYear: "Kies jaar",
    chooseMonth: "Kies maand",
    chooseDate: "Kies datum",
    aria: {
      previousPageLabel: "Vorige pagina",
      prevPageLabel: "Vorige pagina",
      nextPageLabel: "Volgende pagina",
      rowsPerPageLabel: "Rijen per pagina",
    },
  },
  ko: {
    monthNames: [
      "1월",
      "2월",
      "3월",
      "4월",
      "5월",
      "6월",
      "7월",
      "8월",
      "9월",
      "10월",
      "11월",
      "12월",
    ],
    monthNamesShort: [
      "1월",
      "2월",
      "3월",
      "4월",
      "5월",
      "6월",
      "7월",
      "8월",
      "9월",
      "10월",
      "11월",
      "12월",
    ],
    dayNames: [
      "일요일",
      "월요일",
      "화요일",
      "수요일",
      "목요일",
      "금요일",
      "토요일",
    ],
    dayNamesShort: ["일", "월", "화", "수", "목", "금", "토"],
    dayNamesMin: ["일", "월", "화", "수", "목", "금", "토"],
    today: "오늘",
    clear: "지우기",
    apply: "적용",
    cancel: "취소",
    weekHeader: "주",
    chooseYear: "연도 선택",
    chooseMonth: "월 선택",
    chooseDate: "날짜 선택",
    aria: {
      previousPageLabel: "이전 페이지",
      prevPageLabel: "이전 페이지",
      nextPageLabel: "다음 페이지",
      rowsPerPageLabel: "페이지당 행 수",
    },
  },
  de: {
    monthNames: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez",
    ],
    dayNames: [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
    ],
    dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    today: "Heute",
    clear: "Löschen",
    apply: "Anwenden",
    cancel: "Abbrechen",
    weekHeader: "Wo",
    chooseYear: "Jahr wählen",
    chooseMonth: "Monat wählen",
    chooseDate: "Datum wählen",
    aria: {
      previousPageLabel: "Vorherige Seite",
      prevPageLabel: "Vorherige Seite",
      nextPageLabel: "Nächste Seite",
      rowsPerPageLabel: "Zeilen pro Seite",
    },
  },
};
